var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1StPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.9278,
    y1: 89.2634,
    x2: 187.2478,
    y2: 223.7535,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#62E1FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A2F3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M153.084,507.526l-38.097-67.186L38.492,451.01c-7.019,0.979-12.274-6.295-9.14-12.651 l87.315-177.044L256,330.032l-87.315,177.044C165.55,513.433,156.581,513.691,153.084,507.526z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.7611,
    y1: 61.3941,
    x2: 164.4011,
    y2: 246.5741,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A2F3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0075CD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M256,330.032l-45-22.193l-24.666-12.166l-69.666-34.358l-13.625,27.627l11.912,11.912 c0.034,0.046,0.068,0.091,0.102,0.137l2.01,17.161c0.445,3.801,2.46,7.104,5.376,9.262l90.31,90.31L256,330.032z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.5073,
    y1: 108.6837,
    x2: 193.6473,
    y2: 236.7437,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3C3C3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    points: "114.987,440.339 131.388,469.263 211,307.84 161.667,283.509 82.055,444.933 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.0496,
    y1: 104.9538,
    x2: 132.5096,
    y2: 264.7238,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3C3C3",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#777777"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    points: "161.667,283.509 134.211,339.181 175.286,380.256 211,307.84 186.334,295.674 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.6952,
    y1: 89.2514,
    x2: 322.3752,
    y2: 223.7414,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF4C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M358.916,507.526l38.097-67.186l76.495,10.671c7.019,0.979,12.274-6.295,9.14-12.651 l-87.315-177.044L256,330.032l87.315,177.044C346.45,513.433,355.419,513.691,358.916,507.526z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 484.9583,
    y1: 48.883,
    x2: 267.5083,
    y2: 266.3329,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M482.647,438.36l-87.315-177.044L256,330.032l20.292,41.145l102.064,102.064l18.657-32.902 l76.495,10.671C480.528,451.99,485.783,444.716,482.647,438.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.5015,
    y1: 28.5752,
    x2: 309.2215,
    y2: 222.0052,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3C3C3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    points: "397.013,440.339 380.612,469.263 301,307.84 350.332,283.509 429.944,444.933 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.476,
    y1: 432.5827,
    x2: 442.086,
    y2: 136.9807,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M444.134,199.385l-15.582,19.731c-2.681,3.395-3.57,7.873-2.386,12.035l6.867,24.16 c1.71,6.015-0.944,12.413-6.406,15.455l-21.942,12.219c-3.784,2.107-6.324,5.903-6.828,10.205l-2.924,24.964 c-0.726,6.199-5.616,11.089-11.815,11.815l-24.963,2.924c-4.301,0.504-8.098,3.044-10.205,6.828l-12.218,21.942 c-3.042,5.462-9.442,8.115-15.456,6.406l-24.16-6.867c-4.162-1.183-8.639-0.295-12.035,2.386l-19.73,15.582 c-4.896,3.866-11.806,3.866-16.702,0l-19.731-15.582c-3.395-2.681-7.873-3.57-12.035-2.386l-24.16,6.867 c-6.014,1.71-12.413-0.944-15.455-6.406l-12.219-21.942c-2.107-3.784-5.903-6.324-10.205-6.828l-24.964-2.924 c-6.199-0.726-11.089-5.616-11.815-11.815l-2.924-24.962c-0.504-4.301-3.044-8.098-6.828-10.205L85.37,270.769 c-5.462-3.042-8.115-9.442-6.406-15.456l6.867-24.16c1.183-4.162,0.295-8.639-2.386-12.035l-15.582-19.73 c-3.866-4.896-3.866-11.806,0-16.702l15.582-19.731c2.681-3.395,3.569-7.873,2.386-12.035l-6.867-24.16 c-1.71-6.014,0.944-12.413,6.406-15.455l21.942-12.219c3.784-2.107,6.324-5.903,6.828-10.205l2.924-24.964 c0.726-6.199,5.616-11.089,11.815-11.815l24.963-2.924c4.301-0.504,8.098-3.044,10.205-6.828l12.218-21.942 c3.042-5.462,9.442-8.115,15.456-6.406l24.16,6.867c4.162,1.183,8.639,0.295,12.035-2.386L247.646,2.9 c4.896-3.866,11.806-3.866,16.702,0l19.731,15.582c3.395,2.681,7.873,3.569,12.035,2.386l24.16-6.867 c6.014-1.71,12.413,0.944,15.455,6.406l12.219,21.942c2.107,3.784,5.903,6.324,10.205,6.828l24.964,2.924 c6.199,0.726,11.089,5.616,11.815,11.815l2.924,24.963c0.504,4.301,3.044,8.098,6.828,10.205l21.942,12.218 c5.462,3.042,8.115,9.442,6.406,15.456l-6.867,24.16c-1.183,4.162-0.295,8.639,2.386,12.035l15.582,19.73 C448,187.579,448,194.489,444.134,199.385z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.7967,
    y1: 253.2614,
    x2: 132.0867,
    y2: 446.9814,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    cx: 256,
    cy: 191.036,
    r: 125.179
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.7967,
    y1: 253.2614,
    x2: 132.0867,
    y2: 446.9814,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    cx: 256,
    cy: 191.036,
    r: 125.179
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.9654,
    y1: 382.1,
    x2: 354.8054,
    y2: 224.25,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE600"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    cx: 256,
    cy: 191.036,
    r: 101.998
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.6073,
    y1: 241.46,
    x2: 64.1473,
    y2: 369,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5613)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE600",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M383.118,329.967c6.199-0.726,11.089-5.615,11.815-11.815l2.924-24.964 c0.504-4.301,3.044-8.098,6.828-10.205l21.942-12.219c1.728-0.963,3.172-2.262,4.289-3.778L265.417,101.169 c-2.439-1.595-5.167-2.395-8.192-2.395c-2.691,0-4.959,0.926-6.807,2.773l-26.215,25.207c-3.53,2.521-5.294,5.967-5.294,10.335 c0,2.691,0.882,5.167,2.646,7.436l20.797,20.875v109.071c0,2.69,1.299,4.833,3.907,6.428c0.177,0.108,0.362,0.204,0.544,0.305 l84.797,84.986c1.666-1.146,3.095-2.67,4.131-4.53l12.218-21.941c2.107-3.784,5.903-6.324,10.205-6.828L383.118,329.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB92D"
    },
    d: "M218.909,137.09c0-4.368,1.765-7.815,5.294-10.335l26.215-25.207 c1.847-1.847,4.116-2.773,6.807-2.773c3.025,0,5.753,0.8,8.192,2.395c2.434,1.599,3.655,3.742,3.655,6.428v166.874 c0,2.69-1.347,4.833-4.033,6.428c-2.689,1.599-5.798,2.394-9.326,2.394c-3.699,0-6.85-0.796-9.453-2.394 c-2.608-1.595-3.907-3.739-3.907-6.428V134.317l-8.823,11.092c-1.681,1.682-3.528,2.52-5.546,2.52c-2.521,0-4.663-1.134-6.428-3.402 C219.792,142.257,218.909,139.78,218.909,137.09z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1StPlace);
export default __webpack_public_path__ + "static/media/icon-1st-place.3d86b08409ef26a602e7d2bdd3aa9d1e.svg";
export { ForwardRef as ReactComponent };